import { Handshake, Building2 } from "lucide-react";

/**
 * HIGH #7 & #9 — Strategic Associations panel used on Home + About.
 * Content is verbatim from the Phase 1 Execution Brief. When commercials
 * or membership numbers change, update the DATA array below only.
 */
const ASSOCIATIONS = [
  {
    id: "rfpcl",
    icon: Building2,
    tag: "Anchor FPO · Badnapur Taluka",
    name: "Rajewadi Farmer Producer Company Limited",
    lead: "TrueRoots Agro Foods LLP is engaged in a strategic association with Rajewadi Farmer Producer Company Limited (RFPCL) — the anchor FPO for the Rajewadi cluster in Badnapur taluka, Jalna district.",
    body: "RFPCL operates a Pack House and Sorting & Grading facility (7 TPH) in Rajewadi village, Badnapur taluka. This partnership formalises last-mile aggregation, farmer education, and price-transparent procurement of Jalna Sweet Lime (Mosambi) under the TrueRoots One traceability rail.",
  },
  {
    id: "mahasangh",
    icon: Handshake,
    tag: "District Federation",
    name: "Jalna Jilha Phale va Mosambi Bagayatdar Sangh",
    lead: "TrueRoots also works in association with the Jalna Jilha Phale va Mosambi Bagayatdar Sangh — the district-wide federation of fruit and Mosambi growers.",
    body: "This alignment extends TrueRoots' outreach across Ambad, Ghansawangi, Badnapur and Jalna talukas, and anchors the roadmap for grower training, GAP adherence and market-linkage clinics.",
  },
];

export default function StrategicAssociations({ variant = "light" }) {
  const dark = variant === "dark";
  return (
    <section data-testid="strategic-associations" className={dark ? "bg-[var(--tr-deep-green)] text-white tr-grain" : "bg-white"}>
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20">
        <div className={`tr-eyebrow ${dark ? "!text-[var(--tr-citrus-yellow)] before:!bg-[var(--tr-citrus-yellow)]" : ""}`}>
          Strategic Associations
        </div>
        <h2 className={`mt-4 font-display font-extrabold text-3xl md:text-4xl leading-tight ${dark ? "text-white" : "tr-section-title"}`}>
          Partnerships that anchor every fruit we procure.
        </h2>
        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-6">
          {ASSOCIATIONS.map((a) => {
            const Icon = a.icon;
            return (
              <div
                key={a.id}
                data-testid={`assoc-${a.id}`}
                className={`rounded-3xl p-8 md:p-10 ${
                  dark
                    ? "bg-white/6 border border-white/12 backdrop-blur"
                    : "tr-card"
                }`}
              >
                <div className="flex items-center gap-3">
                  <Icon className={`w-7 h-7 ${dark ? "text-[var(--tr-citrus-yellow)]" : "text-[var(--tr-zest)]"}`} />
                  <div className={`text-[11px] font-bold uppercase tracking-[0.22em] ${dark ? "text-white/60" : "text-[var(--tr-muted)]"}`}>
                    {a.tag}
                  </div>
                </div>
                <h3 className={`mt-4 font-display font-extrabold text-xl md:text-2xl leading-tight ${dark ? "text-white" : "text-[var(--tr-deep-green)]"}`}>
                  {a.name}
                </h3>
                <p className={`mt-4 leading-relaxed ${dark ? "text-white/85" : "text-[var(--tr-deep-green)]"}`}>{a.lead}</p>
                <p className={`mt-3 leading-relaxed text-sm ${dark ? "text-white/70" : "text-[var(--tr-muted)]"}`}>{a.body}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
